import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './completed.css'; // Importing the CSS file for styling

const Completed = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Push a dummy entry so the back button hits it first
        window.history.pushState(null, '', window.location.href);

        const handlePopState = () => {
            navigate('/login', { replace: true });
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [navigate]);

    return (
        <div className="centered">
          <div className="common-form-style">
            <div className="page-title">Signing Up is Completed!</div>
            <p>
              Thank you. Your application is completed.<br />
              Someone from our team will be contacting you shortly.
            </p>
            <p>You could log in and edit your information any time.</p>
          </div>
        </div>
    );
  };

export default Completed;
